new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
            .then(res => {
                const actualElement = event.target;
                if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                    $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                }
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.remove('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.add('is-selected');
                actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);   
                actualElement.closest('.product__colors-item').classList.add('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                var sizes = [];
                for (i = 0; i <= res.data.variations.length - 1; i++) {
                    if (res.data.variations[i].main_attribute != null) {
                        sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                    }
                }
                for (i = 0; i <= sizes.length - 1; i++) {
                    if (sizes[i].main_attribute != null) {
                        var randomNumber = Math.floor(Math.random() * 99999999);
                        var stock = sizes[i].available == false ? 'out-of-stock' : '';
                        actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                    }
                }
                if (res.data.addons.length) {
                    var complements = document.createElement('div');
                    complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                    complements.setAttribute('class', 'complements');
                    complements.setAttribute('complements-for', `${id}`);
                    complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                    for (i = 0; i <= res.data.addons.length - 1; i++) {
                        var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                        var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                        complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                        if (res.data.addons[i].field_type == "radio_options") {
                            var complementsSelect = document.createElement('select');
                            complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                            complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                            for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                            }
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content');
                            $(selectDiv).append(complementsSelect);
                            $(complements).append(selectDiv);
                        } else if (res.data.addons[i].field_type == "text") {
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content-area');
                            $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                            $(complements).append(selectDiv);
                        }
                    }
                    $('.kitcolors').closest('.itens-for-carousel').append(complements);
                }
                $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function() {
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);  
                });
                if (window.outerWidth <= 991) {
                    var slickSlider = $('.product-detail__header--photoArea-mobile');

                    if (slickSlider.hasClass('slick-initialized')) {
                        slickSlider.slick('slickRemove', null, null, true);
                    } else {
                        slickSlider.slick();
                    }
                
                    for (i = 0; i < res.data.images.length; i++) {
                        slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                    }
                
                    slickSlider.slick('slickGoTo', 1);
                } else {
                    const noThumbs = document.querySelector('#product-photo');
                    if (noThumbs) {
                        var noThumbsUl = document.querySelector('#product-photo ul');

                        // Remova todos os spans dentro do noThumbsUl
                        while (noThumbsUl.firstChild) {
                            noThumbsUl.removeChild(noThumbsUl.firstChild);
                        }

                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            var li = document.createElement('li');
                            li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                            noThumbsUl.appendChild(li);
                        }
                    } else {
                        $('.sp-wrap').each(function() {
                            $(this).closest('.slick-slide').remove();
                        });
                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                            if (i == 0) {
                                document.querySelector('.sp-wrap').click();
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        updateImage(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = src;
            this.isVideo = false;
        },

        updateVideo(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = false;
            this.isVideo = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElements = document.querySelectorAll(".product-detail__fixed--buy, .fixed-buy-product");
                otherElements.forEach(function (element) {
                    element.classList.remove("active");
                });
            } else {
                const otherElements = document.querySelectorAll(".product-detail__fixed--buy, .fixed-buy-product");
                otherElements.forEach(function (element) {
                    element.classList.add("active");
                });
            }
        },

        moveToBuy() {
            var productSize = document.getElementById("product-size");
            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth" });
            }
        }
    },
    created() {
        const label = document.querySelector('.product-detail__header .product-detail__header--infoArea .product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
    },
    mounted() {
        this.checkBuyView();
        window.addEventListener("scroll", this.checkBuyView, { passive: true });

        const detailOptions = document.querySelector('.product-detail__header--infoArea-kit .product-radio-variation');
        if (detailOptions) {
            let cloneDetailOptions = detailOptions.cloneNode(true);
            let optionsFixedProduct = document.querySelector('.fixed-buy-product .apeend-options');
            optionsFixedProduct?.append(cloneDetailOptions);

            let options = detailOptions.querySelectorAll('label');
            if (options.length) {
                options.forEach((item) => {
                    item.addEventListener('click', () => {
                        options.forEach(opt => opt.classList.remove('active'));
                        item.classList.add('active');
                    })
                });
            }
        }

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        if (window.matchMedia("(min-width: 992px)").matches) {
            if ($('.product-rating__review-list')) {
                $('.product-rating__review-list').slick({
                    swipeToSlide: true,
                    touchThreshold: 100,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    speed: 100,
                });
            }
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    // --- cashback abaixo do preco ---
    // O script de cashback da plataforma injeta a .section-cashback depois do
    // primeiro botao comprar do DOM, que aqui e o da .fixed-buy-product (onde
    // fica escondida). Movemos para logo abaixo do preco da PDP; como a injecao
    // e assincrona (axios), observamos o DOM em vez de mover uma unica vez
    (function initCashbackPosition() {
        const priceArea = document.querySelector('.product-detail__container .product-detail__header--infoArea-price');
        if (!priceArea) return;

        function moveCashback() {
            const cashBack = document.querySelector('.section-cashback');
            if (!cashBack) return;
            // ja esta no lugar certo, evita loop de mutation
            if (cashBack.previousElementSibling === priceArea) return;

            priceArea.insertAdjacentElement('afterend', cashBack);
        }

        moveCashback();

        let scheduled = false;
        const observer = new MutationObserver(function () {
            if (scheduled) return;

            // agrupa as mutations do mesmo frame numa unica verificacao
            scheduled = true;
            window.requestAnimationFrame(function () {
                scheduled = false;
                moveCashback();
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    })();

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
            addToCartButtons.forEach(button => {
                button.classList.add('no-buy');
            });
            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {

                var activeSlide = splide.Components.Slides.getAt(splide.index).slide;

                var productKit = activeSlide.querySelector('.js_product_item_kit');

                var noVariations = productKit?.dataset.noVariations === 'true';

                var radioChecked = activeSlide.querySelector(
                    '.product-radio-variation input[type="radio"]:checked'
                );

                if (radioChecked || noVariations) {

                    splide.go('>');

                    actual = Math.min(actual + 1, end);

                    nextButton.setAttribute('data-actual', actual);

                    message.classList.remove('show');

                    // último slide libera compra
                    if (actual === end) {
                        document.querySelectorAll('.js-btn__product_detail__add_to_cart')
                            .forEach(button => {
                                button.classList.remove('no-buy');
                            });
                    }

                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isAllowSelectProducts = () => {
            const buyTogetherApi = document.querySelector('.buy-together-api');
            return buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products');
        };

        const getGroupsToCheck = () => {
            const allGroups = getGroups();

            // Se tiver .allow-select-products, filtra apenas grupos com checkbox marcado
            if (isAllowSelectProducts()) {
                return allGroups.filter(group => {
                    // MASTER GROUP (group_0): sempre obrigatório, independente do checkbox
                    if (group.dataset.isMasterGroup === 'true') {
                        return true;
                    }

                    // Demais grupos: só verifica se o checkbox estiver marcado
                    const checkbox = group.querySelector('.checkbox-together-selectable');
                    return checkbox && checkbox.checked;
                });
            }

            // Caso contrário, retorna todos os grupos
            return allGroups;
        };

        const isGroupSelected = (group) => {
            if (!group) return false;
            const options = group.querySelector('.product-item__options');
            if (!options) return false;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via inputs (ex: radio)
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback): considera preenchido se houver value não vazio
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i => (i.type !== 'radio' && i.type !== 'checkbox') && i.value && String(i.value).trim() !== '');
            }

            // CORREÇÃO: Se não há nenhum select/input de variação,
            // o produto não tem variação — considera como selecionado
            return true;
        };

        const updateUI = () => {
            const allGroups = getGroups();
            const groupsToCheck = getGroupsToCheck();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!allGroups.length || !addCartBtn) return;

            // Atualiza classe please-select por grupo (todos os grupos)
            allGroups.forEach(group => {
                const selected = isGroupSelected(group);
                group.classList.toggle('please-select', !selected);
            });

            // Regra: liberar compra quando TODOS os grupos a verificar tiverem seleção
            // Se tiver .allow-select-products, só verifica grupos com checkbox marcado
            // Caso contrário, verifica todos os grupos presentes
            const allSelected = groupsToCheck.length > 0 && groupsToCheck.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            const buyTogetherApi = document.querySelector('.buy-together-api');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica mudanças nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable')) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica cliques nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable') ||
                    target.closest('.checkbox-together-selectable')) {
                    // pequeno defer para permitir atualização de checked
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            // Se tiver .allow-select-products, adiciona listeners específicos para os checkboxes
            if (buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products')) {
                // Event listener no buy-together-api para capturar checkboxes que podem estar fora do container
                // Usa delegação de eventos para capturar checkboxes adicionados dinamicamente
                const handleCheckboxChange = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable'))) {
                        updateUI();
                    }
                };

                const handleCheckboxClick = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable'))) {
                        // pequeno defer para permitir atualização de checked
                        setTimeout(updateUI, 10);
                    }
                };

                buyTogetherApi.addEventListener('change', handleCheckboxChange, { passive: true });
                buyTogetherApi.addEventListener('click', handleCheckboxClick, { passive: true });

                // Também adiciona listener no documento para garantir que capture todas as mudanças
                // mesmo que o checkbox seja adicionado dinamicamente em outro lugar
                document.addEventListener('change', (e) => {
                    const target = e.target;
                    if (target && target.classList.contains('checkbox-together-selectable') &&
                        buyTogetherApi.contains(target)) {
                        updateUI();
                    }
                }, { passive: true });

                document.addEventListener('click', (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable')) &&
                        buyTogetherApi.contains(target.closest('.checkbox-together-selectable') || target)) {
                        setTimeout(updateUI, 10);
                    }
                }, { passive: true });

                // Observa mudanças de atributos (checked) nos checkboxes
                const checkboxObserver = new MutationObserver((mutations) => {
                    let shouldUpdate = false;
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' &&
                            (mutation.attributeName === 'checked' || mutation.attributeName === 'class')) {
                            shouldUpdate = true;
                        }
                    });
                    if (shouldUpdate) {
                        updateUI();
                    }
                });

                // Observa todos os checkboxes existentes e futuros
                const observeCheckboxes = () => {
                    const checkboxes = buyTogetherApi.querySelectorAll('.checkbox-together-selectable');
                    checkboxes.forEach(checkbox => {
                        checkboxObserver.observe(checkbox, {
                            attributes: true,
                            attributeFilter: ['checked', 'class']
                        });
                    });
                };

                // Observa adição de novos checkboxes e mudanças no DOM
                const checkboxContainerObserver = new MutationObserver((mutations) => {
                    let shouldObserve = false;
                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldObserve = true;
                        }
                    });
                    if (shouldObserve) {
                        observeCheckboxes();
                        // Pequeno delay para garantir que o DOM foi atualizado
                        setTimeout(updateUI, 10);
                    }
                });
                checkboxContainerObserver.observe(buyTogetherApi, {
                    childList: true,
                    subtree: true,
                    attributes: false
                });

                // Inicializa observação dos checkboxes existentes
                observeCheckboxes();
            }

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });
            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        // Inicializa estado
        updateUI();
    });

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        appendArrows: ".product-detail__showcase--controls-slick",
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    arrows: true
                }
            },
        ]
    })

    // if (window.matchMedia("(min-width: 992px)").matches) {
    //     function animeScroll() {
    //         const photoScroll = document.querySelector('.product-detail__header--photoArea');
    //         const sidebarInner = document.querySelector('.sidebar__inner');

    //         if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
    //             const containerWidth = $('.product-detail__header--infoArea').width();
    //             const sidebarInnerHeight = sidebarInner.offsetHeight;
    //             const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
    //             const pageTop = window.pageYOffset;
    //             const rect = photoScroll.getBoundingClientRect();
    //             const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

    //             if (pageTop > (offsetTop + totalHeight)) {
    //                 $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%', paddingRight: '0' });
    //             } else if (pageTop > offsetTop) {
    //                 $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px', paddingRight: '40px' });
    //             } else {
    //                 $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%', paddingRight: '0' });
    //                 $('.sidebar__inner').css({ paddingTop: '0' + 'px' });
    //             }
    //         }
    //     }

    //     window.addEventListener('scroll', function () {
    //         animeScroll();
    //     });

    //     animeScroll();
    // }

    waitForElementToExist('.custom-description--images').then(element => {
        $('.custom-description--images').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });


    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                prevArrow: $(".count-1 .count-prev"),
                nextArrow: $(".count-1 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    const brinde = document.querySelector('.product-detail__brinde');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const buyTogether = document.querySelector('.product-detail__buy-together');

    if (buyTogether) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                    if (options) {
                                        options.classList.toggle('frente');
                                    }
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        if (options) {
                                            options.classList.toggle('frente');
                                        }
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                    }
                });
            });
        });

        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });

    }
})